<template>
  <div style="height: 100%;">

    <div class="flex justify-between" style="flex: none;">
      <div class="btn-box">
        <gj-button @click="routerTo('/sale/review')" :disabled="noSelect||type==='msku'">查看Review</gj-button>
        <gj-button @click="routerTo('/sale/listing')" :disabled="noSelect">查看Listing</gj-button>
        <gj-button @click="routerTo('/statistics/profit-statistics')" :disabled="noSelect">查看利润统计</gj-button>
        <gj-button @click="routerTo('/logistics/deliveryPlan')" v-if="$permission('shipPlan:add')" :disabled="noSelect">
          创建发货计划
        </gj-button>
        <gj-button @click="batchOffer" :disabled="noSelect||!$permission('listing:view')" :loading="batchOfferLoading">批量调价</gj-button>
        <gj-button @click="editStatus()" :disabled="noSelect||type!=='msku'||!$permission('listing:view')">修改运营状态</gj-button>
        <span class="btn-box-str size12 color666">已选{{ selectedRows.length }}条</span>
      </div>
      <gj-tool-group
          ref="toolGroup"
          setting
          :table-name="'dashboard-sale-instant-table-3.1.1'"
          :table-columns="columns"
      ></gj-tool-group>
    </div>

    <div>
      <gj-table
          ref="gjTable"
          :adapt-height="false"
          :height="clientWidth >= 1600?500:400"
          :index="false"
          :loading="loading"
          :data="tableData"
          :columns="columns"
          :pagination="pagination"
          border
          selection
          :pageSizes="[20,50]"
          :tree-config="treeConfig"
          :default-sort="{prop: 'todaySaleQuantity', order: 'descending'}"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery"
          :show-overflow="false">

        <template v-slot:imageUrl="{row}">
          <gj-image
              :src="row.imageUrl"
              :tag-color="tagColors.orange"
              :tag="row.variationAsin ? '变' : null">
          </gj-image>
        </template>

        <!--            ASIN-->
        <template v-slot:asin="{row}">
          <template v-if="type === 'variationAsin'">
            <gj-link v-if="row.isTreeChild" :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
            <gj-link v-else :href="row.variationAsinUrl" target="_blank">{{row.variationAsin | defaultShow}}</gj-link>
          </template>
          <template v-else-if="type === 'asin'">
<!--            <span v-if="row.isTreeChild">{{row.msku | defaultShow}}</span>-->
<!--            <gj-link v-else :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>-->
            <gj-link :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
          </template>
          <span v-else>{{row.msku | defaultShow}}</span>
          <!--        <span v-if="type === 'variationAsin'">-->
          <!--          <gj-link :href="row.variationAsinUrl" target="_blank">{{ row.variationAsin | defaultShow }}</gj-link>-->
          <!--        </span>-->
          <!--        <span v-else-if="type === 'msku'">{{ row.msku | defaultShow }}</span>-->
          <!--        <span v-else>-->
          <!--          <gj-link :href="row.asinUrl" target="_blank">{{ row.asin | defaultShow }}</gj-link>-->
          <!--        </span>-->
        </template>

        <!--            分析-->
        <template v-slot:asins="{ row }">
          <gj-icon iconfont="iconshuju1" @click.native="handleNavigateAsin(row)" class="analysis-icon"></gj-icon>
        </template>

        <!-- 星级 -->
        <template v-slot:star="{row}">
          <div v-if="row.star">
            <el-popover trigger="click" placement="bottom" @hide="starChartHide" @after-enter="getStarData(row)"
                        popper-class="no-padding-poppers">
              <!-- 悬浮展示的内容 -->
              <div style="width: 700px;min-height: 440px;">
                <StarChart v-if="starChartShow" :commentBarData="starData" :row="row"/>
              </div>
              <div slot="reference">
                {{ row.star }}
                <i v-if="row.starRise===true" class="iconfont iconxiangshang size12 colorGreen"></i>
                <i v-if="row.starRise===false" class="iconfont iconxiangxia size12 colorRed"></i>
              </div>
            </el-popover>
          </div>
          <div v-else>-</div>
        </template>

        <!--            品牌-->
        <template v-slot:brandName="{row}">
          <gj-tooltip
              :text-line="1"
              :content="row.brandName"
              class="listing-title">
            {{ row.brandName | defaultShow }}
          </gj-tooltip>
        </template>

        <!--            品类-->
        <template v-slot:categoryName="{row}">
          <gj-tooltip
              :text-line="1"
              :content="row.categoryName"
              class="listing-title">
            {{ row.categoryName | defaultShow }}
          </gj-tooltip>
        </template>

        <!--            运营状态-->
        <template v-slot:operationStatus="{row}">
          {{ row.operationStatus }}
          <div
              v-if="type==='msku'&&$permission('listing:view')"
              class="editIcon"
              :class="{ 'gj-cell-display-switch': true }"
              @click="editStatus(row.listingId, row.operationStatus)"
          >
            <i class="el-icon-edit"></i>
          </div>
        </template>

        <!--      原价-->
        <template v-slot:yourPrice="{row}">
          <gj-tooltip>
            {{ row.yourPrice | defaultShow }}
            <div
                v-if="$permission('listing:view')&&type==='msku'"
                class="editIcon"
                :class="{ 'gj-cell-display-switch': true }"
                @click="singleOffer(row)"
            >
              <i class="el-icon-edit"></i>
            </div>
            <template #content>
              优惠时间：{{row.saleStartDate?row.saleStartDate.slice(0,10):'-'}} - {{row.saleEndDate?row.saleEndDate.slice(0,10):'-'}}
            </template>
          </gj-tooltip>
        </template>

        <!--      优惠价-->
        <template v-slot:salePrice="{row}">
          <gj-tooltip>
            {{ row.salePrice | defaultShow }}
            <div
                v-if="$permission('listing:view')&&type==='msku'"
                class="editIcon"
                :class="{ 'gj-cell-display-switch': true }"
                @click="singleOffer(row)"
            >
              <i class="el-icon-edit"></i>
            </div>
            <template #content>
              优惠时间：{{row.saleStartDate?row.saleStartDate.slice(0,10):'-'}} - {{row.saleEndDate?row.saleEndDate.slice(0,10):'-'}}
            </template>
          </gj-tooltip>

        </template>

        <!-- 排名 -->
        <template v-slot:bsr="{row}">
          <div v-if="row.mainBsr || row.subBsr" slot="reference" class="bsr-content">
            <div>
              <el-popover
                  style="padding: 0"
                  popper-class="no-padding-poppers"
                  trigger="click"
                  placement="bottom"
                  @after-enter="getBsrData(row)">
                <RankingChart :rankingData="rankingData" :row="row"/>
                <gj-icon
                    slot="reference"
                    class="analysis-icon"
                    @click.native="handRankingChart(row)"
                    iconfont="iconshuju">
                </gj-icon>
              </el-popover>
            </div>
            <div>
              <div class="gj-table--label">
                {{ row.mainBsr | defaultShow }}
                <i v-if="row.mainRise===true" class="iconfont iconxiangshang size12 colorGreen"></i>
                <i v-if="row.mainRise===false" class="iconfont iconxiangxia size12 colorRed"></i>
              </div>
              <div class="gj-table--label">
                {{ row.subBsr | defaultShow }}
                <i v-if="row.subRise===true" class="iconfont iconxiangshang size12 colorGreen"></i>
                <i v-if="row.subRise===false" class="iconfont iconxiangxia size12 colorRed"></i>
              </div>
            </div>
          </div>
          <span v-else>-</span>
        </template>

        <!--      FBA可售-->
        <template v-slot:fbaInventoryQuantity="{ row }">
          <gj-popover-panel title="FBA可售"
                            :width="'180px'"
                            :data="buildFBA(row)">
            {{ row.fbaInventoryQuantity | defaultShow }}
          </gj-popover-panel>
        </template>

        <!--      FBM可售-->
        <template v-slot:fbmInventoryQuantity="{ row }">
          <gj-popover-panel title="FBM可售"
                            :width="'180px'"
                            :data="buildFBM(row)">
            {{ row.fbmInventoryQuantity | defaultShow }}
          </gj-popover-panel>
        </template>

        <template #empty v-if="!showStoreMask">
          <div></div>
        </template>

      </gj-table>
    </div>

  </div>

</template>

<script>
import {dashboardMixin, queryMixin, selectionMixin} from "@/minxins";
import {tagColors} from "@/components/tag/tag-colors";
import {
  getBsrInfo,
  getItemSaleBoardPage, getItemSaleBoardPageDetail,
  getSeaSellerAssistantPage,
  getStarInfo,
  listingSaleBoard
} from "@/api/dashboard";
import {isMeaningful, isMeaningless} from "@/utils/common";
import EditStatusModal from "@/views/modules/home/components/sale/components/edit-status-modal";
import RankingChart from "@/views/modules/home/components/sale/components/ranking-chart";
import StarChart from "@/views/modules/home/components/sale/components/star-chart";
import AppProductOfferModal from "@/views/modules/sale/listing/modal/product-offer-modal";
import AppSaleInstantSingleOfferModal from "@/views/modules/home/components/sale/modal/sale-instant-single-offer-modal";
import {mapGetters} from "vuex";

export default {
  name: "sale-instant-table",
  mixins: [queryMixin, selectionMixin, dashboardMixin],
  components: {RankingChart, StarChart},
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    model: {
      type: Object,
      default: () => {
      }
    },
    type: null,
    typeSef: null,
  },
  created() {
    this.sort.prop = 'todaySaleQuantity';
  },
  data() {
    return {
      batchOfferLoading: false,
      loading: false,
      tagColors,
      starChartShow: false,

      staticTreeConfig: {lazy: true, children: 'children', hasChild: 'hasChild', loadMethod: this.expandLazyLoad},
      rankingData: {},    // 排名趋势图数据
      starData: {},        // 星级趋势图数据

      tableData: []
    }
  },
  watch: {
    filter: {
      handler: function (n, o) {
        if (this.typeSef === this.type) {
          this.$gjNoticeQuery();
          this.$nextTick(() => {
            this.$refs.toolGroup.getCustomData()
          })
        }
      },
      // immediate: true
    },
  },
  computed: {
    // filter() {
    //   return {
    //     type: this.type,
    //     dateTime: this.timezoneText,
    //     currency: this.dashboardCurrency,
    //     countryMarket:this.countryMarket
    //   }
    // },
    treeConfig() {
      return this.type === 'variationAsin'
          ? this.staticTreeConfig
          : null;
    }
  },
  methods: {
    //单条调价
    singleOffer(row) {
      const vm = this;
      const modal = this.$gjCreate(AppSaleInstantSingleOfferModal, {
        props: {
          params: {
            id: row.listingId,
            yourPrice: row.yourPrice,
            salePrice: row.salePrice,
            saleStartDate: row.saleStartDate,
            saleEndDate: row.saleEndDate
          }
        },
        on: {
          after() {
            vm.$gjResetPage();
            modal.$gjDestroy();
          }
        }
      });
    },
    // 批量调价
    async batchOffer() {
      let rows;
      if (this.type === 'msku') {
        rows = this.selectedRows
      }
      // 若不是通过msku查询 需要调接口获取数据
      else {
        this.batchOfferLoading = true
        let param = {
          groupType: this.type,
          listingList: this._.uniqBy(this.selectedRows.map(r => {
            return {
              marketId: r.marketId,
              [this.type]: r[this.type]
            }
          }), this.type)
        }
        await listingSaleBoard(param).then(data => {
          rows = data;
          rows.forEach(r => {
            r.saleDate = [r.saleStartDate || '', r.saleEndDate || ''];
          })
        })
      }
      const modal = this.$gjCreate(AppProductOfferModal, {
        props: {
          rows: rows,
        },
        on: {
          after: () => {
            this.$gjResetPage();
            modal.$gjDestroy();
          }
        }
      })
      this.batchOfferLoading = false
    },
    // 跳转
    routerTo(path) {
      // if(this.selectedRows.length === 0){
      //   this.$message.warning('请先勾选')
      //   return
      // }
      let query = {
        timeStamp: new Date().getTime(),
        routeValue: null,
        routeKey: null
      };
      // 跳转review
      if (path === '/sale/review') {
        // 只有asin
        let val = this.selectedRows.map(r => r.asinStr).join(',').split(',');
        query.routeValue = this._.uniq(val).join(',');
        query.date=[];
        query.routeKey = 'asinList';
        query.countryIds = this._.uniq(this.selectedRows.map(r => r.country)).join(',');
      }
      // 跳转listing
      else if (path === '/sale/listing') {
        query.routeKey = this.type;
        // 根据type
        query.routeValue = this._.uniq(this.selectedRows.map(r => r[this.type])).join(',');
        query.marketIds = this._.uniq(this.selectedRows.map(r => r.marketId)).join(',');
        query.countryIds = this._.uniq(this.selectedRows.map(r => r.country)).join(',');
      }
      // 跳转利润统计
      else if (path === '/statistics/profit-statistics') {
        query.routeKey = this.type;
        query.routeValue = this._.uniq(this.selectedRows.map(r => r[this.type])).join(',');
        query.marketIds = this._.uniq(this.selectedRows.map(r => r.marketId)).join(',');
        query.countryIds = this._.uniq(this.selectedRows.map(r => r.country)).join(',');
      }
      // 跳转发货计划
      else if (path === '/logistics/deliveryPlan') {
        let isSame = this.selectedRows[0].marketId;
        query.routeValue = this.selectedRows.map(r => {
          if (isSame !== r.marketId) {
            isSame = false
          }
          return {
            filterFieldType: this.type,
            filterFieldValue: r[this.type],
            marketId: r.marketId
          }
        })
        if (!isSame) {
          this.$message.warning('仅支持同一个店铺国家商品创建发货计划')
          return;
        }
        query.routeValue = this._.uniqBy(query.routeValue,'filterFieldValue')
        query.countryCode = this.selectedRows[0].country;
        query.routeKey = query.routeValue[0].marketId;
      }
      this.$router.push({path, query})
    },
    $gjQuery() {
      if(!this.showStoreMask){
        return
      }
      // 缓存了时区时，第一次不请求
      if(isMeaningful(this.timezoneId)&&isMeaningless(this.timezoneText)){
        return
      }
      // 构造查询参数
      const params = {
        model: {
          ...this.model,
          currency: this.dashboardCurrency,// 币种
          marketTime: this.timezoneText,// 时区日期
          // marketTime: '2022-01-27 20:20:20',
        },
        ...this.querySort,
        ...this.queryPagination,
      };
      this.globalParams = params;
      // 查询
      this.loading = true;
      getItemSaleBoardPage(params)
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = data.records;
              this.tableData.forEach(item => {
                item.hasChild = !item.nonVariationAsin;
                item.saleDate = [item.saleStartDate || '', item.saleEndDate || ''];
              });
              this.pagination = this.getPagination(data);
            } else {
              this.tableData = [];
            }
          })
          .complete(() => this.loading = false);
    },
    //异步获取父asin展开数据
    expandLazyLoad({row}) {
      let param = {
        currency: this.dashboardCurrency,
        marketTime: this.timezoneText,
        marketIds: [row.marketId],
        ...this.querySort
      };
      if(this.type === 'variationAsin'){
        param = {
          groupType: 'asin',
          variationAsin: row.variationAsin,
          ...param
        }
      }else if(this.type === 'asin'){
        param = {
          groupType: 'msku',
          asin: row.asin,
          ...param
        }
      }
      return getItemSaleBoardPageDetail(param).then(data=>{
        data.forEach(r=>r.isTreeChild = true);
        return Promise.resolve(data)
      })
    },
    // expandLazyLoad({row}) {
    //   const params = this._.cloneDeep(this.globalParams);
    //   params.model.groupType = 'asin';
    //   params.model.asinList = row.asinList.map(item => item.asin);
    //   params.current = 1;
    //   params.size = 99999;
    //   return getSeaSellerAssistantPage(params).then((data) => {
    //     data.records.forEach(item => item.nonVariationAsin = true);
    //     return Promise.resolve(data.records)
    //   });
    // },

    // 获取排名趋势图的数据
    getBsrData(row) {
      const params = {
        asin: row.asin,
        marketId: row.marketId,
      }
      getBsrInfo(params).then(data => {
        if (isMeaningful(data)) {
          this.rankingData = JSON.parse(JSON.stringify(data))
        } else {
          this.rankingData = {}
        }
      })
    },
    handRankingChart(row) {
    },
    // 修改运营状态
    editStatus(id, status) {
      let listingId;
      if (id) {
        listingId = [id]
      } else {
        if (this.selectedRows.length === 0) {
          this.$message.warning('请先勾选')
          return
        }
        listingId = this.selectedRows.map(r => r.listingId)
      }
      this.$gjCreate(EditStatusModal, {
        props: {
          listingId,
          status,
          batch: !id
        },
        on: {
          editStatus: () => {
            this.$gjQuery();
          },
        },
      });
    },
    // 跳转asin分析
    handleNavigateAsin(row) {
      const params = {
        asinType: (this.type === 'asin' || row.isTreeChild) ? 'child' : 'parent',// 'child'  'parent'
        asinCode: (this.type === 'asin' || row.isTreeChild) ? row.asin : row.variationAsin,
        countryData: {
          countryIds: [row.country], // 国家
          marketIds: [row.marketId], // 店铺
        },
        date: {
          type: 'DAY',
          value: []
        }
      }
      this.$router.push({path: '/statistics/asin-361-analysis', query: {params: JSON.stringify(params)}})
    },
    //
    starChartHide() {
      this.starChartShow = false
      this.starData = {}
    },
    // 获取星级趋势图的数据
    getStarData(row) {
      this.starChartShow = true
      const params = {
        asin: row.asin,
        country: row.country
      }

      getStarInfo(params).then(data => {
        if (isMeaningful(data)) {
          this.starData = data
        } else {
          this.starData = {}
        }
      })
    },

    /**
     * popover详情
     * @param row
     */
    buildFBA(row) {
      return [
        [
          {label: 'FBA可售', value: row.fbaInventoryQuantity}
        ],
        [
          {label: '转运中', value: row.reservedTransfers},
          {label: '处理中', value: row.reservedProcessing},
          {label: '小计', value: row.reservedSum, bold: true},
        ],
        [
          {label: '计划入库', value: row.planInboundQuantityFBA},
          {label: '已发货', value: row.alreadyShipQuantity},
          {label: '入库中', value: row.inboundingQuantity},
          {label: '小计', value: row.quantityFBA, bold: true}
        ]
      ]
    },
    /**
     * popover详情
     */
    buildFBM(row) {
      return [
        [
          {label: 'FBM可售', value: row.fbmInventoryQuantity}
        ],
        [
          {label: '采购量', value: row.purchaseQuantity},
          {label: '已下单', value: row.alreadyOrderQuantity},
          {label: '交货量', value: row.deliveryQuantity},
          {label: '计划入库', value: row.planInboundQuantityFBM},
          {label: '小计', value: row.quantityFBM, bold: true}
        ]
      ]
    },
  }
}
</script>

<style scoped lang="scss">
/deep/ .vxe-table .lazy-tree-child-row {
  background: #F6F7F8;
}
.btn-box {
  margin-bottom: 12px;

  /deep/
  .el-button + .el-button {
    margin-left: 12px;
  }

  .btn-box-str {
    margin-left: 16px;
  }
}
</style>